import { TextField, Button } from '@material-ui/core'
import React from 'react'
import { useFormik } from 'formik'
import axios from 'axios'

const AddBranch = props => {
    const formik = useFormik({
        initialValues: {
            name: ""
        },
        onSubmit: values => {
            axios.post('accounts/branch/', {
                bank_id: props.bankID,
                name: values.name
            }).then(result => {
                props.setBranchesState([...props.branchesState, result.data])
                props.setPopup(false)
            })
        }
    })
    return (
        <form onSubmit={formik.handleSubmit}>
            <TextField
                id="name"
                label="نام شعبه"
                fullWidth
                value={formik.values.name}
                onChange={formik.handleChange}
            />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                style={{ marginTop: 10 }}
                disabled={formik.isSubmitting}
            >
                افزودن
            </Button>
        </form>
    )
}

export default AddBranch